var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SegmentationBulkEdit"}},[_c('BulkEditor',{attrs:{"columns":_vm.columns,"source":_vm.segments,"validate-row":_vm.validateRow,"loading":_vm.loading,"resource-name":{
      singular: _vm.$t('campaignEdit.bulkEdit.segment'),
      plural: _vm.$t('campaignEdit.bulkEdit.segments')  
    },"allow-delete":"","allow-copy":false,"allow-create":false},on:{"view-row":_vm.viewRow,"commit":_vm.saveSegmentChanges,"discard":_vm.onDiscard},scopedSlots:_vm._u([{key:"col:type",fn:function(ref){
    var value = ref.value;
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.label)+"\n    ")]}},{key:"col:tag",fn:function(ref){
    var value = ref.value;
return [_vm._v("\n      "+_vm._s(value ? value : '—')+"\n    ")]}},{key:"col:status",fn:function(ref){
    var value = ref.value;
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.label)+"\n    ")]}},{key:"col:offerIds",fn:function(ref){
    var value = ref.value;
    var item = ref.item;
return [_vm._v("\n      #"+_vm._s(item.id)+" - "+_vm._s(item.displayText)+" - "+_vm._s(item.promoCode)+"\n    ")]}},{key:"col:widgetId",fn:function(ref){
    var value = ref.value;
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item ? item.name : '—')+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }